"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getIllustrationColor_1 = __importDefault(require("../formulas/getIllustrationColor"));
var useTheme_1 = __importDefault(require("./useTheme"));
/**
 * Useful information for displaying SVGs on a block background.
 *
 * Returns the action color (background.click.base) unless it is too close to white or black.
 * In that case returns block.base.
 *
 * Also returns isLight which should be used to pick which SVG to use.
 *
 *    return isLight ? <LightBackgroundSVG /> : <DarkBackgroundSVG />
 */
function useIllustrationColor() {
    return (0, getIllustrationColor_1.default)((0, useTheme_1.default)());
}
exports.default = useIllustrationColor;
//# sourceMappingURL=useIllustrationColor.js.map